import { render, staticRenderFns } from "./gonggaoxq.vue?vue&type=template&id=f1f6bf76&scoped=true&"
import script from "./gonggaoxq.vue?vue&type=script&lang=js&"
export * from "./gonggaoxq.vue?vue&type=script&lang=js&"
import style0 from "./gonggaoxq.vue?vue&type=style&index=0&id=f1f6bf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f6bf76",
  null
  
)

export default component.exports